import Connector from '../../agent';
import types from './types';
import { takeQuery } from 'react-lib/dist/agent-es';

const Competencies = {
  getRequiredCompetencies: () => Connector.api.get('/competencies/getRequired')
};

const competenciesSagas = [
  takeQuery(types.GET_REQUIRED_COMPETENCIES, Competencies.getRequiredCompetencies)
];

export default competenciesSagas;
